export const BASE_URL = "";

export const BASE_APP_HOSTNAME = "";

export const getBaseAppUrl = () => {
  return window.location.protocol + "//" +
    (BASE_APP_HOSTNAME === "" ? window.location.hostname : BASE_APP_HOSTNAME);
}
